<template>
  <div>
    <div v-if="header">
      <div class="no-data-with-header">
        <slot name="header" />
        <div class="flex flex-col items-center">
          <img :src="require('@/assets/shipo-sales-plan-no-data.svg')">
          <h3 class="no-data-with-header-title">
            {{ title }}
          </h3>
          <span class="no-data-with-header-subtitle">{{ message }}</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="no-data">
        <img :src="require('@/assets/shipo-sales-plan-no-data.svg')">
        <h3 class="no-data-title">
          {{ title }}
        </h3>
        <span class="no-data-subtitle">{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    title: {
      type: String,
      default: () => 'No Preview Data'
    },
    message: {
      type: String,
      default: () => 'Uploaded data files will be displayed here'
    },
    header: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>

<style lang="scss" scoped>
  .no-data {
    @apply bg-white;
    @apply flex;
    @apply flex-wrap;
    @apply flex-col;
    @apply justify-center;
    @apply items-center;
    padding: 5.5rem;
    border-radius: 1.2rem;

    &-title {
      @apply text-grey;
      @apply text-2xl;
      @apply font-semibold;
      @apply mt-10;
    }

    &-subtitle {
      @apply text-grey-001;
      @apply mt-1;
    }
  }

  .no-data-with-header {
    @apply p-5 flex flex-col bg-white rounded-2xl;

    &-title {
      @apply text-grey;
      @apply text-2xl;
      @apply font-semibold;
      @apply mt-10;
    }

    &-subtitle {
      @apply text-grey-001;
      @apply mt-1;
    }
  }
</style>
